import produce from 'immer';
import { GET_ALL_TEAM_SUCCESS } from './constants';

const INITIAL_STATE = {
    // businesses.businesseList
    teamList: []
};

const usersReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_ALL_TEAM_SUCCESS:
            draft.teamList = action.payload;
            break;

        default:
    }
}, INITIAL_STATE);

export default usersReducer;
